import React, { useState, useEffect } from 'react';
import './../to-do-list/to-do-list.css';

function ToDoList() {
  const [tasks, setTasks] = useState([]);
  const [input, setInput] = useState('');

  // Carregar tarefas do localStorage ao montar o componente
  useEffect(() => {
    const storedTasks = localStorage.getItem('tasks');
    if (storedTasks) {
      setTasks(JSON.parse(storedTasks));
    }
  }, []);

  // Atualizar localStorage sempre que as tarefas mudarem
  useEffect(() => {
    localStorage.setItem('tasks', JSON.stringify(tasks));
  }, [tasks]);

  const addTask = () => {
    const trimmedInput = input.trim();
    if (trimmedInput === '') return;
    const newTask = {
      id: Date.now(),
      text: trimmedInput,
      completed: false,
    };
    setTasks([...tasks, newTask]);
    setInput('');
  };

  const toggleTask = (id) => {
    setTasks(tasks.map(task =>
      task.id === id ? { ...task, completed: !task.completed } : task
    ));
  };

  const deleteTask = (id) => {
    setTasks(tasks.filter(task => task.id !== id));
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      addTask();
    }
  };

  return (
    <div className="container my-2 app h-50">
      <div className="d-flex col-12 justify-content-center">
        <div className='d-flex'>
          <h3 className="mb-2">Controle de Tarefas</h3>
        </div>    
      </div>

      <div className="row mb-3">
        <div className="col-9 inp-task">
          <input
            type="text"
            className="form-control "
            placeholder="Digite uma nova tarefa"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyPress={handleKeyPress}
          />
        </div>
        <div className="col">
          <button className="btn btn-primary w-100  btn-t-mobile" onClick={addTask}>
            Adicionar
          </button>

        </div>
      </div>
      <ul className="list-group task-list">
        {tasks.map(task => (
          <li key={task.id} className="list-group-item d-flex justify-content-between align-items-center">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                checked={task.completed}
                onChange={() => toggleTask(task.id)}
                id={`task-${task.id}`}
              />
              <label className={`form-check-label ${task.completed ? 'text-decoration-line-through text-muted' : ''}`} htmlFor={`task-${task.id}`}>
                {task.text}
              </label>
            </div>
            <button className="btn btn-danger btn-sm " onClick={() => deleteTask(task.id)}>
              Excluir
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ToDoList;
